import { Message } from 'semantic-ui-react';

export default Message;
